export function getOutcome(score) {
  if (score.home === score.away) return "draw";
  return score.home > score.away ? "home" : "away";
}

export function calculatePredictionPoints(prediction, result, multiplier = 1) {
  if (!prediction || !result) {
    return { points: 0, basePoints: 0, outcomeType: "pending" };
  }

  const exactScore = prediction.homeScore === result.home && prediction.awayScore === result.away;
  const correctOutcome = getOutcome({ home: prediction.homeScore, away: prediction.awayScore }) === getOutcome(result);
  const basePoints = exactScore ? 9 : correctOutcome ? 3 : 0;

  return {
    points: Number((basePoints * multiplier).toFixed(2)),
    basePoints,
    outcomeType: exactScore ? "exact" : correctOutcome ? "outcome" : "none"
  };
}

export function outcomeDelta(previousType = "none", nextType = "none") {
  const previousOutcome = previousType === "exact" || previousType === "outcome" ? 1 : 0;
  const nextOutcome = nextType === "exact" || nextType === "outcome" ? 1 : 0;
  const previousExact = previousType === "exact" ? 1 : 0;
  const nextExact = nextType === "exact" ? 1 : 0;

  return {
    correctOutcomes: nextOutcome - previousOutcome,
    exactScores: nextExact - previousExact
  };
}
